<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :setLoading="setLoading"
    :loadDataGrid="loaded"
    ref="sales-contract-list"
    :persistenceKey="'sales-contract-list'"
    v-if="loaded"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";

import TransactionListTemplate from "../../templates/transaction-list";
import {
  SalesContractTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/sales/sales-contracts-tabs";
import ColumnWidth from '../../_helpers/data-grid/ColumnWidth';

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      setLoading: false,
      loaded: false,
    };
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Sales Contracts",
        ScreenName: "Sales Contracts - All",
        selectedIndex: GetIndexByTabName("All"),
        tabs: SalesContractTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "CustomerSalesContractList",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
              select: [
                "CustomerSalesContractCode",
                "CustomerCode",
                "CustomerName",
                "CustomerSalesContractEndDate",
                "CustomerSalesContractName",
                "CustomerSalesContractStartDate",
                "CustomerSalesContractStatus",
                "ContractSearchText",
                "FriendlyStatus",
                "MarketCode",
              ],
            },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Contracts",
                message: "Get Started, Add a Contract",
              },
            },
          },

          toolbar: {
            search: false,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/sales-contract/create",
                clickAction: {},
                buttonLocation: "left",
              },
            ],
            filterOnEnter: true,
          },
          columns: [
            {
              screenField: "Contract",
              gridDataField: "CustomerSalesContractCode",
              sortOrder: "desc",
              dataType: "string",
              type: "Text",
              sortIndex: 0,
              filterDataField: "ContractSearchText",
              filterIndex: 0,
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "CustomerSalesContractName",
                  },
                ],
                secondary: [
                  {
                    dataField: "CustomerSalesContractCode",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "CustomerSalesContractCode",
                  label: "Contract Code",
                },
                {
                  dataField: "CustomerSalesContractName",
                  label: "Contract Description",
                },
              ],
            },
            {
              screenField: "Customer",
              filterIndex: 2,
            },
            {
              screenField: "StartDate",
              dataField: "CustomerSalesContractStartDate",
              filterDataField: "CustomerSalesContractStartDate",
              filterIndex: 3,
            },
            {
              screenField: "EndDate",
              dataField: "CustomerSalesContractEndDate",
              filterDataField: "CustomerSalesContractEndDate",
              filterIndex: 4,
            },
            {
              screenField: "OrderStatus",
              gridDataField: "FriendlyStatus",
              filterDataField: "FriendlyStatus",
              filterIndex: 1,
              dataSourceConfig: {
                data: ["Active", "Completed"],
              },
            },
            {
              screenField: "Market",
              filterDataField: "MarketCode",
              dataField: "MarketCode",
              maxWidth: ColumnWidth.Market.minWidth,
              filterIndex: 5,
            }
          ],
        },
      };

      return config;
    },
  },
  methods: {
    rowClickCallBack(e) {
      if (e.rowType == "data" && e.column.screenField != "OrderStatus") {
        this.onRowClicked(e, {
          view: this,
          page: "sales-contract",
          mode: "review",
          idProperty: "CustomerSalesContractCode",
        });
      }
    },
  },

  async created() {
    this.setLoading = true;
    this.loaded = true;
  },
};
</script>

<style lang="scss"></style>
